import { koComponent } from '../ko-utils';

class IntegrateSlackButton {
    constructor(params, customParams) {
        this.connectUrl = ko.computed(() => {
            // Just for dependency tracking
            customParams.activeTab();

            return `/api/v1/integrations/auth/slack/redirect/${window.auth.project.UniqueCode}?redirectBackUrl=${encodeURIComponent(window.location.href)}`;
        });
    }
}

export default koComponent('integrate-slack-button', IntegrateSlackButton);